
const initialState = {
	display_snackbar: false,
	snackbar_message: 'Geen bericht',
}

export const SnackbarReducer = (state = initialState, action = {}) => {
   switch (action.type) {

        case 'SET_SNACKBAR_MESSAGE':
        	return {
                ...state,
                display_snackbar: true,
                snackbar_message: action.payload,
            };
        case 'UNSET_SNACKBAR_MESSAGE':
            return {
                ...state,
                display_snackbar: false,
                snackbar_message: '',
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/SnackbarReducer.js